/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetSpecialOrdersForVCCByVccDate,
    ApproveVCCSpecialOrder,
    RejectVCCSpecialOrder,
    GetSupplierDetailsForOrder,
    GetSupplierCropVarityQuntityDetails,
    AddSpecialOrderSuppliers,
    RemoveSpecialOrderSuppliers,
    EditSpecialOrderSuppliers,
    ApproveSpecialOrderReadyToWeighment,
    AddDirectSupplier,
    GetDirectSupplierDetails,
    UpdateDirectSupplierDetails,
    GetFarmerDetailsByFactoryIDRouteID,
    GetRouteByFactoryID,
    UpdateSpecialOrder
};

async function GetRouteByFactoryID(factoryID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(factoryID));
    return response.data;
}


async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetAllFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}


async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetSpecialOrdersForVCCByVccDate(operationEntityID, date) {
    const response = await CommonGet('/api/SpecialOrder/GetSpecialOrdersForVCCByVccDate', 'operationEntityID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}

async function ApproveVCCSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/ApproveVCCSpecialOrder', null, data);
    return response;
}

async function RejectVCCSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/RejectVCCSpecialOrder', null, data);
    return response;
}

async function GetSupplierDetailsForOrder(operationEntityID, cropID, date) {
    const response = await CommonGet('/api/SpecialOrder/GetSupplierDetailsForSpecialOrder', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetSupplierCropVarityQuntityDetails(cropID) {
    const response = await CommonGet('/api/SpecialOrder/GetSupplierCropVarityDetailsForSpecialOrder', 'cropID=' + parseInt(cropID));
    return response.data;
}

async function AddSpecialOrderSuppliers(supplierOrderDeails, supplierData) {
    var values = {
        specialOrderID: parseInt(supplierOrderDeails.specialOrderID),
        cropForecastDetailID: parseInt(supplierData.cropForecastDetailID),
        operationEntityID: parseInt(supplierOrderDeails.operationEntityID),
        farmerID: parseInt(supplierData.farmerID),
        cropID: parseInt(supplierOrderDeails.cropID),
        cropVarietyID: parseInt(supplierData.cropVarityID),
        dueDate: supplierOrderDeails.orderDate,
        productCode: supplierOrderDeails.productCode,
        acceptedQuantity: parseFloat(supplierData.quantity),
        availbaleQuantity: parseFloat(supplierData.availbaleQty),
        remainingQuantity: parseFloat(supplierData.reaminCount),
        isDirectSupplier: supplierData.supplierTypeID == 1 ? false : true,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/SpecialOrder/AddSpecialOrderSuppliers', null, values);
    return response;
}

async function RemoveSpecialOrderSuppliers(supplierData, supplierOrderDeails) {
    var values = {
        specialOrderFarmerMappingID: parseInt(supplierData.specialOrderFarmerMappingID),
        specialOrderID: parseInt(supplierOrderDeails.specialOrderID),
        cropForecastDetailID: parseInt(supplierData.cropForecastDetailID),
        operationEntityID: parseInt(supplierOrderDeails.operationEntityID),
        cropID: parseInt(supplierOrderDeails.cropID),
        acceptedQuantity: parseFloat(supplierData.acceptedQuantity),
        dueDate: supplierOrderDeails.orderDate,
        productCode: supplierOrderDeails.productCode,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/SpecialOrder/RemoveSpecialOrderSupplier', null, values);
    return response;
}

async function EditSpecialOrderSuppliers(supplierData, supplierOrderUpdateDeails, supplierOrderDeails) {
    var values = {
        specialOrderFarmerMappingID: parseInt(supplierOrderUpdateDeails.specialOrderFarmerMappingID),
        specialOrderID: parseInt(supplierData.specialOrderID),
        cropForecastDetailID: parseInt(supplierOrderDeails.cropForecastDetailID),
        acceptedQuantity: parseFloat(supplierOrderDeails.quantity),
        acceptedOldQuantity: parseFloat(parseFloat(supplierOrderUpdateDeails.acceptedQuantity) - parseFloat(supplierOrderDeails.quantity)),
        existsQuantity: parseFloat(supplierOrderDeails.availbaleQty),
        existsAcceptedQuantity: ((parseFloat(supplierData.acceptedQuantity) - parseFloat(supplierOrderUpdateDeails.acceptedQuantity)) + parseFloat(supplierOrderDeails.quantity)),
        dueDate: supplierData.orderDate,
        productCode: supplierData.productCode,
        operationEntityID: parseInt(supplierData.operationEntityID),
        cropID: parseInt(supplierData.cropID),
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/SpecialOrder/EditSpecialOrderSupplier', null, values);
    return response;
}

async function ApproveSpecialOrderReadyToWeighment(data) {
    var values = {
        specialOrderFarmerMappingID: parseInt(data.specialOrderFarmerMappingID),
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/SpecialOrder/ApproveSpecialOrderReadyToWeighment', null, values);
    return response;
}

async function AddDirectSupplier(data, groupID, operationEntityID) {
    var values = {
        groupID: groupID,
        operationEntityID: operationEntityID,
        phoneNumber: data.phoneNumber == "" ? parseInt(0) : parseInt(data.phoneNumber),
        directSupplierName: data.directSupplierName,
        isActive: data.isActive,
        brNumber: data.brNumber,
        nic: data.nic,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/SpecialOrder/AddDirectSupplierDetails', null, values);
    return response;
}

async function GetDirectSupplierDetails(operationEntityID) {
    const response = await CommonGet('/api/SpecialOrder/GetDirectSupplierDetails', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function UpdateDirectSupplierDetails(data) {
    var values = {
        directSupplierID: data.directSupplierID,
        phoneNumber: data.phoneNumber == "" ? parseInt(0) : parseInt(data.phoneNumber),
        directSupplierName: data.directSupplierName,
        isActive: data.isActive,
        brNumber: data.brNumber,
        nic: data.nic,
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/SpecialOrder/UpdateDirectSupplierDetails', null, values);
    return response;
}

async function UpdateSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/UpdateSpecialOrder', null, data);
    return response;
}